import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import axios from "axios";

import DashboardSidebar from "../../components/dashboard components/DashboardSidebar";
import DashboardHeader from "../../components/dashboard components/DashboardHeader";
import StatisticsForm from "../../components/dashboard components/forms/StatisticsForm";

// ✅ Use environment variable for API base
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE = `${API_BASE_URL}/trustbar`;

const Trustbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Default seed (used when API is empty or fails)
  const [statsData, setStatsData] = useState([
    { value: "18+ lakh", label: "sq. ft. delivered" },
    { value: "3 RERA", label: "approved projects" },
    { value: "Since 2003", label: "in South India" },
  ]);

  // ===============================
  // FETCH FROM API
  // ===============================
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(API_BASE);

        if (Array.isArray(res.data) && res.data.length > 0) {
          const mapped = res.data.map((row) => ({
            value: row.value || "",
            label: row.label || "",
          }));
          setStatsData(mapped);
        }
      } catch (err) {
        console.error("Error loading trustbar stats:", err);
      }
    };

    fetchStats();
  }, []);

  // ===============================
  // SAVE TO API
  // ===============================
  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Please login again.");
        return;
      }

      await axios.post(
        `${API_BASE}/save`,
        { stats: statsData },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Statistics saved successfully!");
    } catch (err) {
      console.error("Error saving trustbar stats:", err);
      alert("Failed to save trustbar stats. Check console for details.");
    }
  };

  // ===============================
  // RENDER
  // ===============================
  return (
    <div className="flex min-h-screen bg-gray-50 font-sans">
      {/* Sidebar - Desktop */}
      <div className="hidden lg:block">
        <DashboardSidebar />
      </div>

      {/* Sidebar - Mobile */}
      <div
        className={`fixed inset-y-0 left-0 bg-white w-72 shadow-2xl transform transition-transform duration-300 ease-in-out z-50 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } lg:hidden`}
      >
        <DashboardSidebar />
        <button
          type="button"
          aria-label="Close sidebar"
          className="absolute top-4 right-4 text-gray-500 hover:text-blue-600"
          onClick={() => setSidebarOpen(false)}
        >
          <X size={28} />
        </button>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <button
          type="button"
          className="fixed inset-0 bg-black bg-opacity-30 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main */}
      <main className="flex-1 flex flex-col w-full">
        {/* Top bar */}
        <div className="sticky top-0 bg-white z-30 shadow-sm flex items-center justify-between px-4 sm:px-8 py-4 border-b border-gray-200">
          <button
            type="button"
            className="lg:hidden text-gray-700 hover:text-blue-600"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu size={28} />
          </button>
          <div className="flex-1 flex justify-center">
            <DashboardHeader title="Trustbar Management" backTo="/dashboard" />
          </div>
        </div>

        {/* Content */}
        <section className="flex-1 overflow-y-auto px-3 sm:px-6 lg:px-10 py-6 sm:py-10 bg-gray-50">
          <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-4 sm:p-6 md:p-8 lg:p-10 border border-gray-100">
            <StatisticsForm
              statsData={statsData}
              setStatsData={setStatsData}
              onSave={handleSave}
            />
          </div>
        </section>
      </main>
    </div>
  );
};

export default Trustbar;
